import auth1 from "../assets/pictures/home/auth_15.webp";
import auth2 from "../assets/pictures/home/authentic_22.webp";
import auth3 from "../assets/pictures/home/auth_44.webp";
import authv1 from "../assets/videos/auth11.webm";
import s2 from "../assets/pictures/home/grid2.jpeg";
import s3 from "../assets/pictures/home/grid3.jpeg";
import s4 from "../assets/pictures/home/grid4.jpeg";
import a1 from "../assets/pictures/home/authentic_11.webp";
import a2 from "../assets/pictures/home/authentc_33.webp";
import a3 from "../assets/pictures/home/auth_55.webp";
import a4 from "../assets/pictures/home/auth_66.webp";
import a5 from "../assets/pictures/home/auth16.webp";
import a6 from "../assets/pictures/home/auth17.webp";


import { cls } from "../components/Utility";
import { Link } from "react-router-dom";
import DesktopWa from "../components/DesktopWa";
import Call from "../components/Call";

export default function AuthenticStories() {
  return (
    <>
      <div className={cls("hidden", "xl:flex")}>
        <div className="relative w-full h-screen overflow-hidden">
          <div className="w-full h-full">
            <img src={auth1} />
          </div>
          <div className="absolute inset-x-0 bottom-[60px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[25px] font-semibold tracking-widest fadeInUp ">
                AUTHENTIC X LOVE STORIES 2024
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        <div className="relative w-full overflow-hidden">
          <img src={auth1} className="w-full h-[500px] object-cover" />

          <div className="absolute inset-x-0 top-[420px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[20px] font-semibold tracking-widest fadeInUp ">
                AUTHENTIC X LOVE STORIES 2024
              </h1>
            </div>
          </div>
        </div>
      </div>
      <p className="mt-[30px] mb-[30px] text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px]">
        We specialize in crafting innovative and authentic moments, transforming
        them into timeless memories. With a perfect blend of creativity and
        passion, we deliver experiences that are as unique as your story. At the
        heart of our premium photography lies a commitment to capturing emotions
        that last forever.
      </p>

      <div
        className={cls(
          "flex flex-col pl-[20px] pr-[20px] gap-[10px] mb-[30px] mt-[40px]",
          "xl:flex xl:justify-center xl:flex-row xl:gap-[30px] "
        )}
      >
        <img
          src={auth2}
          className="xl:w-[600px] xl:h-[700px] w-full h-[500px] object-cover"
        />
        <img
          src={auth3}
          className="xl:w-[600px] xl:h-[700px] w-full h-[500px] object-cover"
        />
      </div>

      <div className="flex justify-center mb-[30px] pl-[20px] pr-[20px] xl:pl-0 xl:pr-0">
        <video
          className="xl:w-[700px] xl:h-[800px] w-full h-[600px] object-cover"
          autoPlay
          loop
          muted
        >
          <source src={authv1} type="video/mp4" />
        </video>
      </div>

      <div
        className={cls(
          "flex flex-col gap-[10px] pl-[20px] pr-[20px] mb-[10px]",
          "xl:flex xl:flex-row xl:justify-center xl:gap-[1px] xl:mb-[1px] "
        )}
      >
        <img
          src={a1}
          className="xl:w-[370px] xl:h-[500px] w-full h-[400px] object-cover"
        />
        <img
          src={a2}
          className="xl:w-[370px] xl:h-[500px] w-full h-[400px] object-cover"
        />
        <img
          src={a3}
          className="xl:w-[370px] xl:h-[500px] w-full h-[400px] object-cover"
        />
      </div>

      {/* <div className="flex justify-center xl:pl-0 xl:pr-0 pl-[20px] pr-[20px]">
        <img
          src={auth2}
          className="xl:w-[600px] xl:h-[500px] w-full h-[400px] object-cover mb-[30px]"
        />
      </div>
      <p className="tracking-widest text-[25px] font-semibold font-[Headings] text-center xl:pl-0 xl:pr-0 pl-[20px] pr-[20px]">
        AUTHENTICITY MEETS ELEGANCE
      </p>
      <Link to="/authenticity-meets-elegance">
        <div className="flex justify-center mb-[40px] ">
          <div className="rounded-none border-[1.5px] pt-[10px] pb-[10px] pl-[20px] pr-[20px] bg-[black] mt-[20px] text-white font-[Headings] text-[16px] w-[200px] text-center">
            EXPLORE
          </div>
        </div>
      </Link> */}


      <div
        className={cls(
          "flex flex-col pl-[20px] pr-[20px] gap-[10px] mb-[40px]",
          "xl:flex xl:flex-row xl:gap-[1px] xl:justify-center "
        )}
      >
        <img src={a4} className="xl:w-[370px] xl:h-[500px] object-cover" />
        <img src={a5} className="xl:w-[370px] xl:h-[500px] object-cover" />
        <img src={a6} className="xl:w-[370px] xl:h-[500px] object-cover" />
      </div>
      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9980685056" />
      </div>
    </>
  );
}
